import get from 'just-safe-get'
import { getCookie } from 'utils/cookies'

const getFeatureFlagCookie = () => {
  const featureFlagCookie = getCookie('feature-flag-cookie')

  if (!featureFlagCookie) {
    return null
  }

  try {
    return JSON.parse(featureFlagCookie)
  } catch (error) {
    console.error('Error parsing feature flag cookie', error) // eslint-disable-line no-console
    return null
  }
}

type ExperimentNames = 'rasa-order-flow'
type ExperimentVersion = 'default' | 'rasa'

const experimentPathMap: Record<ExperimentNames, string> = {
  'rasa-order-flow': 'pdcuse-215.v.v_name',
}

export const isFeatureFlagEnabled = (
  featureFlags: Record<string, any> | null | undefined,
  experimentName: ExperimentNames,
  value: ExperimentVersion
): boolean => {
  if (!featureFlags) {
    return false
  }

  return Boolean(get(featureFlags, experimentPathMap[experimentName]) === value)
}

export default getFeatureFlagCookie
